export default __webpack_public_path__ + "static/media/Untitled-3.6851a8e2.png";